import {useMutation} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {ApiResult} from "../../../../types/ApiResult";

export const useMarkAnnouncementAsRead = (
	announcementID: number | undefined,
	onSuccess: () => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("announcement/mark-as-read", {
				announcementID: announcementID
			}) as ApiResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess();
			else
				onError('Error when marking announcement as read: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
